import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { link, breadcrumb, stat } from 'src/app/admin/layout/header/header.component';
import { GlobalConstants } from 'src/app/services/global-constants';
import { DataService } from 'src/app/services/data.service';
import { TranslatorPipe } from 'src/app/services/translator.pipe';
import { DatePipe, Location, formatDate } from '@angular/common';

@Component({
  selector: 'app-assessment-certificate',
  templateUrl: './assessment-certificate.component.html',
  styleUrl: './assessment-certificate.component.scss'
})
export class AssessmentCertificateComponent {

  assessmentId: string = '';
  courseId: string = '';
  header = this.translate('Assessment Certificate');
  links: link[] = [
    {
      name: 'رجوع',
      icon: 'pi pi-angle-right',
      link: '',
    },
  ];
  breadcrumbs: breadcrumb[] = [
    { name: this.translate('assessment'), link: `/assessment/` },
  ];
  queryParams: any = {};
  stats: stat[] = [];
  messages: any[] = [];
  invitees: any[] = [];
  graphData: any[] = [];
  userResults: any[] = [];
  activeTabIndex: number = 0;
  tabIndex: number = 0;
  currentQBankId: string = "";

  skelition: boolean = false;
  isUserTesting: boolean = false;
  download: boolean = false;
  from: string = 'builder';
  email: string = "";
  constructor(
    private route: ActivatedRoute,
    private dataService: DataService,
    private router: Router
  ) { }

  ngOnInit() {

    this.route.queryParams.subscribe(qParams => {
      if (qParams['userTesting'] == 1) {
        this.isUserTesting = true;

      }
      if (!!qParams['courseId']) {
        this.courseId = qParams['courseId'];
      }

      if (!!qParams['from']) {
        this.from = qParams['from'];
      }

      if (qParams['QBankId']) {
        this.currentQBankId = qParams['QBankId'];
      }

      if (qParams['tabIndex']) {
        const savedTabIndex = +qParams['tabIndex'];
        if (!isNaN(savedTabIndex)) {
          this.tabIndex = savedTabIndex;
        }
      }

      if (qParams['activeTabIndex']) {
        const activeTabIndex = +qParams['activeTabIndex'];
        if (!isNaN(activeTabIndex)) {
          this.activeTabIndex = activeTabIndex;
        }
      }

      if (qParams['download']) {
        this.download = (qParams['download'] == 'true') ? true : false;

      }
    });

    this.route.params.subscribe(params => {
      this.assessmentId = params['assessmentId'];
      this.email = params['email'];
      this.header = this.translate('Assessment Certificate');
      if (!!this.courseId) {
        this.breadcrumbs = []
      } else {
        if (this.from == 'profile')
        {
          this.breadcrumbs[0] = { name: this.translate('Profile personly'), link: `/user-profile` };
          this.breadcrumbs[1] = { name: this.translate('Assessment Certificate'), link: `/assessment/certificate/` + this.assessmentId + '/' + this.email, queryParams : { 'from': 'profile'} };
          this.links[0].link = `/user-profile`;
        }
        else{
          this.breadcrumbs[0].queryParams = { 'QBankId': this.currentQBankId, 'tabIndex': this.tabIndex };
          this.breadcrumbs[1] = { 
            name: this.translate('Add a question'), link: `/assessment/add-question/` + this.assessmentId,
            queryParams : { 'QBankId': this.currentQBankId, 'tabIndex': this.tabIndex }
          };
          if (this.isUserTesting)
          {
            this.breadcrumbs[2] = { 
              name: this.translate('Assessment Certificate'), link: `/assessment/certificate/` + this.assessmentId + '/' + this.email,
              queryParams: { 'userTesting':1, 'QBankId': this.currentQBankId, 'tabIndex': this.tabIndex }
            };
          } else{
            this.breadcrumbs[2] = { 
              name: this.translate('Assessment Certificate'), link: `/assessment/certificate/` + this.assessmentId + '/' + this.email,
              queryParams: { 'QBankId': this.currentQBankId, 'tabIndex': this.tabIndex }
            };
          }
          this.links[0].link = `/assessment/add-question/` + this.assessmentId;
          this.links[0].queryParams = { 'QBankId': this.currentQBankId, 'tabIndex': this.tabIndex }
        }
      }
    });
  }

  translate(key: string) {
    let translator: TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }
}
